/* eslint-disable */
import Login from './components/Login';
//import Main from './components/Main';
//import Signup from './components/Signup';
import UserPanel from './components/UserPanel';
import Alert from './components/Alert';
//import UserActive from './components/UserActive';
//import ForgetPassword from './components/ForgetPassword';
//import ResetPassword from './components/ResetPassword';
//import PostDetail from './components/PostDetail';
//import Contactus from './components/Contactus';
//import SessionList from './components/SessionList';
//import NewsDetail from './components/NewsDetail';
//import NotFound from './components/NotFound';

import axios from "axios";
export const routes = [
    {
        path: '/',
        component: UserPanel,
        beforeEnter: (to, from, next) => {
            let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
            if (userInfo === null) {
                next("/login");
            } else {
                next();
                /*axios.get('/GetUserProfile', {
                    headers: {
                        'authorization': userInfo.Token,
                    }
                })
                    .then(function (response) {
                        if (response.data.Status === 1) {
                            next("/userpanel");
                        }
                        else {
                            localStorage.removeItem("UserInfo");
                            next("/login");
                        }
                    })
                    .catch(function () {
                        localStorage.removeItem("UserInfo");
                        next("/login");
                    });*/
            }
        }

    },
    /*{
        path: '/userpanel',
        component: UserPanel,
        beforeEnter: (to, from, next) => {
            let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
            if (userInfo === null) {
                next("/login");
            } else {
                axios.get('/GetUserProfile', {
                    headers: {
                        'authorization': userInfo.Token,
                    }
                })
                    .then(function (response) {
                        if (response.data.Status === 1) {
                            next();
                        }
                        else {
                            next("/login");
                        }
                    })
                    .catch(function (error) {
                        next("/login");
                    });
            }
        }

    }*/
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/alert',
        component: Alert,
    },
    {
        path: '/userpanel/:modulename?',
        component: UserPanel,
        beforeEnter: (to, from, next) => {
            let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
            if (userInfo === null) {
                next("/login");
            } else {
                next();
                /*axios.get('/GetUserProfile', {
                    headers: {
                        'authorization': userInfo.Token,
                    }
                })
                    .then(function (response) {
                        if (response.data.Status === 1) {
                            next();
                        }
                        else {
                            next("/login");
                        }
                    })
                    .catch(function (error) {
                        next("/login");
                    });*/
            }
        }

    }
    // {
    //     path: "*",
    //     component: NotFound
    // }


]